// extracted by mini-css-extract-plugin
export default {"container":"mail_container__2fXz9","mail":"mail_mail__MQNiA","mailText":"mail_mailText__3Zgq4","mailTextBlack":"mail_mailTextBlack__3-6pV"};